
<script setup lang="ts">
import { useRequestURL } from '#imports'

const { breadcrumbs } = useBreadcrumbs()
const localePath = useLocalePath()

const breadcrumbItems = computed(() => breadcrumbs.value ?? [])

// Capture the request origin once at setup so breadcrumb `item` URLs are absolute.
// useRequestURL() must not be called inside a reactive head getter (see useCanonicalUrl).
const origin = import.meta.server ? useRequestURL().origin : window.location.origin

const breadcrumbListSchema = computed(() => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.value.map((breadcrumb, index) => {
        const item: Record<string, unknown> = {
            '@type': 'ListItem',
            position: index + 1,
            name: breadcrumb.name,
        }
        if (breadcrumb.path) {
            item.item = `${origin}${localePath(breadcrumb.path)}`
        }
        return item
    }),
}))

useHead(() => ({
    script: breadcrumbItems.value.length > 0
        ? [jsonLdScript(breadcrumbListSchema.value, 'ld-breadcrumb')]
        : [],
}))
</script>

<template>
    <nav aria-label="breadcrumb" class="text-xs text-base-content-subtle breadcrumbs pt-0 pb-0 leading-6">
        <ul class="breadcrumb">
            <li
                v-for="breadcrumb in breadcrumbItems"
                :key="breadcrumb.path"
            >
                <template v-if="Object.keys(breadcrumb)?.length > 0">
                    <MiscLink
                        v-if="breadcrumb.path"
                        no-prefetch
                        :to="localePath(breadcrumb.path)"
                        class="text-base-content brand-page-color-active:text-brand-page-color"
                    >
                        <span>{{ breadcrumb.name }}</span>
                    </MiscLink>
                    <div v-else>
                        <span>{{ breadcrumb.name }}</span>
                    </div>
                </template>

                <template v-else>
                    <div>
                        <span>{{ breadcrumb.name }}</span>
                    </div>
                </template>
            </li>
        </ul>
    </nav>
</template>
